
// import React, { useState, useEffect, useRef } from "react";
// import "../App.css";

// function Timer() {
//   const [timeLeft, setTimeLeft] = useState(0); // Time left in seconds
//   const [isActive, setIsActive] = useState(false);
//   const [isWorkPhase, setIsWorkPhase] = useState(true);
//   const [roundsCompleted, setRoundsCompleted] = useState(0);

//   // Customizable durations (default values: 1 minute work, 0.5 minute rest)
//   const [workDurationMinutes, setWorkDurationMinutes] = useState(3);
//   const [restDurationMinutes, setRestDurationMinutes] = useState(2);

//   const [totalRounds, setTotalRounds] = useState(12); // Total Tabata rounds

//   // Calculate session duration (in minutes)
//   const sessionDurationMinutes =
//     (workDurationMinutes + restDurationMinutes) * totalRounds;

//   const audioRef = useRef(null);
//   const countdownBeepRef = useRef(null);

//   useEffect(() => {
//     let interval = null;

//     if (isActive && timeLeft > 0) {
//       interval = setInterval(() => {
//         setTimeLeft((prevTime) => prevTime - 1);
//       }, 1000);
//     } else if (isActive && timeLeft === 0) {
//       playSound();
//       if (isWorkPhase) {
//         setIsWorkPhase(false);
//         setTimeLeft(restDurationMinutes * 60); // Convert minutes to seconds
//       } else {
//         setRoundsCompleted((prevRounds) => prevRounds + 1);
//         if (roundsCompleted + 1 < totalRounds) {
//           setIsWorkPhase(true);
//           setTimeLeft(workDurationMinutes * 60); // Convert minutes to seconds
//         } else {
//           setIsActive(false);
//           setIsWorkPhase(true);
//           setRoundsCompleted(0);
//           setTimeLeft(workDurationMinutes * 60); // Reset to work duration
//         }
//       }
//     }

//     return () => clearInterval(interval);
//   }, [isActive, timeLeft, isWorkPhase, roundsCompleted, workDurationMinutes, restDurationMinutes, totalRounds]);

//   useEffect(() => {
//     // Play countdown beep for the last 3 seconds
//     if (isActive && timeLeft <= 3 && timeLeft > 0) {
//       playCountdownBeep();
//     }
//   }, [isActive, timeLeft]);

//   const startTimer = () => {
//     setIsActive(true);
//     setTimeLeft(workDurationMinutes * 60); // Start with work duration in seconds
//   };

//   const stopTimer = () => {
//     setIsActive(false);
//     setTimeLeft(workDurationMinutes * 60); // Reset to work duration
//     setIsWorkPhase(true);
//     setRoundsCompleted(0);
//   };

//   const playSound = () => {
//     if (audioRef.current) {
//       audioRef.current.play().catch((error) => {
//         console.error("Error playing sound:", error);
//       });
//     }
//   };

//   const playCountdownBeep = () => {
//     if (countdownBeepRef.current) {
//       countdownBeepRef.current.currentTime = 0; // Reset the sound to start from the beginning
//       countdownBeepRef.current.play().catch((error) => {
//         console.error("Error playing countdown beep:", error);
//       });
//     }
//   };

//   return (
//     <div className="background-image">
//       <div className="home-page-text">
//         <h1>Tabata Timer</h1>

//         {/* Input Fields for Custom Durations */}
//         <div style={styles.inputContainer}>
//           <label>
//             Work Duration (minutes):
//             <input
//               type="number"
//               step="0.1" // Allow decimal inputs (e.g., 0.5 minutes)
//               value={workDurationMinutes}
//               onChange={(e) => setWorkDurationMinutes(Number(e.target.value))}
//               min="0.1"
//               style={styles.input}
//             />
//           </label>

//           <label>
//             Rest Duration (minutes):
//             <input
//               type="number"
//               step="0.1" // Allow decimal inputs (e.g., 0.5 minutes)
//               value={restDurationMinutes}
//               onChange={(e) => setRestDurationMinutes(Number(e.target.value))}
//               min="0.1"
//               style={styles.input}
//             />
//           </label>

//           <label>
//             Total Rounds:
//             <input
//               type="number"
//               value={totalRounds}
//               onChange={(e) => setTotalRounds(Number(e.target.value))}
//               min="1"
//               style={styles.input}
//             />
//           </label>
//         </div>

//         {/* Display Session Duration */}
//         <p>Total Session Duration: {sessionDurationMinutes.toFixed(2)} minutes</p>

//         <p>{isActive ? (isWorkPhase ? "Work!" : "Rest!") : "Ready?"}</p>
//         <p style={{ fontSize: "48px", fontWeight: "bold" }}>
//           {Math.floor(timeLeft / 60)}:{(timeLeft % 60).toString().padStart(2, "0")}
//         </p>
//         <p>Rounds Completed: {roundsCompleted}/{totalRounds}</p>

//         <div style={{ marginTop: "20px" }}>
//           {!isActive ? (
//             <button onClick={startTimer} style={styles.button}>
//               Start
//             </button>
//           ) : (
//             <button onClick={stopTimer} style={styles.button}>
//               Stop
//             </button>
//           )}
//         </div>

//         {/* Audio Elements for Notifications */}
//         <audio ref={audioRef} src="/beep-07.wav" preload="auto"></audio>
//         <audio ref={countdownBeepRef} src="/button-35.wav" preload="auto"></audio>
//       </div>
//     </div>
//   );
// }

// const styles = {
//   button: {
//     padding: "10px 20px",
//     fontSize: "18px",
//     backgroundColor: "#007bff",
//     color: "#fff",
//     border: "none",
//     borderRadius: "5px",
//     cursor: "pointer",
//   },
//   inputContainer: {
//     display: "flex",
//     flexDirection: "column",
//     gap: "10px",
//     marginBottom: "20px",
//   },
//   input: {
//     marginLeft: "10px",
//     padding: "5px",
//     width: "60px",
//     borderRadius: "5px",
//     border: "1px solid #ccc",
//   },
// };

// export default Timer;

import React, { useState, useEffect, useRef } from "react";
import "../App.css";

function Timer() {
  const [timeLeft, setTimeLeft] = useState(0); // Time left in seconds for the current phase
  const [isActive, setIsActive] = useState(false);
  const [isWorkPhase, setIsWorkPhase] = useState(true);
  const [roundsCompleted, setRoundsCompleted] = useState(0);

  // Customizable durations (default values: 1 minute work, 0.5 minute rest)
  const [workDurationMinutes, setWorkDurationMinutes] = useState(1);
  const [restDurationMinutes, setRestDurationMinutes] = useState(0.5);

  const [totalRounds, setTotalRounds] = useState(8); // Total Tabata rounds

  // Calculate session duration (in seconds)
  const sessionDurationSeconds =
    (workDurationMinutes + restDurationMinutes) * totalRounds * 60;

  // Track total elapsed time in seconds (excluding prepare phase)
  const [elapsedTime, setElapsedTime] = useState(0);

  const audioRef = useRef(null);
  const countdownBeepRef = useRef(null);

  // Add a prepare phase
  const [isPreparePhase, setIsPreparePhase] = useState(false);
  const prepareDuration = 5; // 5 seconds for the prepare phase

  useEffect(() => {
    let interval = null;

    if (isActive && timeLeft > 0) {
      interval = setInterval(() => {
        setTimeLeft((prevTime) => prevTime - 1);

        // Increment elapsed time only if not in the prepare phase
        if (!isPreparePhase) {
          setElapsedTime((prevElapsedTime) => prevElapsedTime + 1);
        }
      }, 1000);
    } else if (isActive && timeLeft === 0) {
      playSound();
      if (isPreparePhase) {
        setIsPreparePhase(false);
        setTimeLeft(workDurationMinutes * 60); // Start the first work phase
      } else if (isWorkPhase) {
        setIsWorkPhase(false);
        setTimeLeft(restDurationMinutes * 60); // Switch to rest phase
      } else {
        setRoundsCompleted((prevRounds) => prevRounds + 1);
        if (roundsCompleted + 1 < totalRounds) {
          setIsWorkPhase(true);
          setTimeLeft(workDurationMinutes * 60); // Switch back to work phase
        } else {
          setIsActive(false);
          setIsWorkPhase(true);
          setIsPreparePhase(false);
          setRoundsCompleted(0);
          setTimeLeft(prepareDuration); // Reset to prepare phase
          setElapsedTime(0); // Reset elapsed time
        }
      }
    }

    return () => clearInterval(interval);
  }, [isActive, timeLeft, isWorkPhase, roundsCompleted, workDurationMinutes, restDurationMinutes, totalRounds]);

  useEffect(() => {
    // Play countdown beep for the last 3 seconds
    if (isActive && timeLeft <= 3 && timeLeft > 0) {
      playCountdownBeep();
    }
  }, [isActive, timeLeft]);

  const startTimer = () => {
    setIsActive(true);
    setIsPreparePhase(true);
    setTimeLeft(prepareDuration); // Start with the prepare phase
    setElapsedTime(0); // Reset elapsed time
  };

  const stopTimer = () => {
    setIsActive(false);
    setIsPreparePhase(false);
    setIsWorkPhase(true);
    setRoundsCompleted(0);
    setTimeLeft(prepareDuration); // Reset to prepare phase
    setElapsedTime(0); // Reset elapsed time
  };

  const playSound = () => {
    if (audioRef.current) {
      audioRef.current.play().catch((error) => {
        console.error("Error playing sound:", error);
      });
    }
  };

  const playCountdownBeep = () => {
    if (countdownBeepRef.current) {
      countdownBeepRef.current.currentTime = 0; // Reset the sound to start from the beginning
      countdownBeepRef.current.play().catch((error) => {
        console.error("Error playing countdown beep:", error);
      });
    }
  };

  return (
    <div className="background-image">
      <div className="TermsAndConditions">
        <h1>Tabata Timer</h1>

        {/* Input Fields for Custom Durations */}
        <div style={styles.inputContainer}>
          <label>
            Work Duration (minutes):
            <input
              type="number"
              step="0.1" // Allow decimal inputs (e.g., 0.5 minutes)
              value={workDurationMinutes}
              onChange={(e) => setWorkDurationMinutes(Number(e.target.value))}
              min="0.1"
              style={styles.input}
            />
          </label>

          <label>
            Rest Duration (minutes):
            <input
              type="number"
              step="0.1" // Allow decimal inputs (e.g., 0.5 minutes)
              value={restDurationMinutes}
              onChange={(e) => setRestDurationMinutes(Number(e.target.value))}
              min="0.1"
              style={styles.input}
            />
          </label>

          <label>
            Total Rounds:
            <input
              type="number"
              value={totalRounds}
              onChange={(e) => setTotalRounds(Number(e.target.value))}
              min="1"
              style={styles.input}
            />
          </label>
        </div>

        {/* Display Session Duration */}
        <p>Total Session Duration: {Math.floor(sessionDurationSeconds / 60)}:{(sessionDurationSeconds % 60).toString().padStart(2, "0")}</p>

        {/* Display Current Phase */}
        <p>{isPreparePhase ? "Prepare!" : isActive ? (isWorkPhase ? "Work!" : "Rest!") : "Ready?"}</p>

        {/* Display Current Phase Timer */}
        <p style={{ fontSize: "48px", fontWeight: "bold" }}>
          {Math.floor(timeLeft / 60)}:{(timeLeft % 60).toString().padStart(2, "0")}
        </p>

        {/* Display Total Elapsed Time */}
        <p>
          Total Time Elapsed:{" "}
          {Math.floor(elapsedTime / 60)}:{(elapsedTime % 60).toString().padStart(2, "0")}
        </p>

        <p>Rounds Completed: {roundsCompleted}/{totalRounds}</p>

        <div style={{ marginTop: "20px" }}>
          {!isActive ? (
            <button onClick={startTimer} style={styles.button}>
              Start
            </button>
          ) : (
            <button onClick={stopTimer} style={styles.button}>
              Stop
            </button>
          )}
        </div>

        {/* Audio Elements for Notifications */}
        <audio ref={audioRef} src="/beep-07.wav" preload="auto"></audio>
        <audio ref={countdownBeepRef} src="/button-35.wav" preload="auto"></audio>
      </div>
    </div>
  );
}

const styles = {
  button: {
    padding: "10px 20px",
    fontSize: "18px",
    backgroundColor: "#007bff",
    color: "#fff",
    border: "none",
    borderRadius: "5px",
    cursor: "pointer",
  },
  inputContainer: {
    display: "flex",
    flexDirection: "column",
    gap: "10px",
    marginBottom: "20px",
  },
  input: {
    marginLeft: "10px",
    padding: "5px",
    width: "60px",
    borderRadius: "5px",
    border: "1px solid #ccc",
  },
};

export default Timer;